<div
  class="tw-my-2 tw-border-0 tw-border-t tw-border-solid tw-border-t-secondary-500"
  role="separator"
></div>
